import { api } from 'src/services';
import { ChartFilter } from 'src/screens/task-chart/filters/filter-type';

function buildFilterParams(filters: ChartFilter): string {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value));
    }
  });

  return params.toString();
}

function downloadBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

function getFilenameFromDisposition(
  disposition: string | undefined,
  fallback: string,
): string {
  if (!disposition) {
    return fallback;
  }

  const match = disposition.match(/filename="?([^"]+)"?/);
  return match?.[1] ?? fallback;
}

export async function exportWorkshopReportCsv(
  reportType: 'tasks' | 'operators',
  filters: ChartFilter,
): Promise<void> {
  const endpoint =
    reportType === 'tasks'
      ? '/tasks/reports/patrimonies/export'
      : '/tasks/reports/operators/export';

  const fallbackFilename =
    reportType === 'tasks'
      ? `relatorio_os_maquinas_${filters.startDate}_${filters.endDate}.csv`
      : `relatorio_os_operadores_${filters.startDate}_${filters.endDate}.csv`;

  const response = await api.get(`${endpoint}?${buildFilterParams(filters)}`, {
    responseType: 'blob',
  });

  const blob =
    response.data instanceof Blob
      ? response.data
      : new Blob([response.data], { type: 'text/csv;charset=utf-8' });

  const filename = getFilenameFromDisposition(
    response.headers['content-disposition'],
    fallbackFilename,
  );

  downloadBlob(blob, filename);
}
